import { render, staticRenderFns } from "./TiktokApi.vue?vue&type=template&id=0575bd5a&scoped=true"
import script from "./TiktokApi.vue?vue&type=script&lang=js"
export * from "./TiktokApi.vue?vue&type=script&lang=js"
import style0 from "./TiktokApi.vue?vue&type=style&index=0&id=0575bd5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0575bd5a",
  null
  
)

export default component.exports